module.exports = __webpack_public_path__ + "assets/img/Currency2.b3ba1aeb.png";